<template>
  <div>
    <v-layout
      align-center
      class="mt-5"
      justify-space-between>
      <div class="title">
        Assigned jobs
      </div>
      <v-btn
        :disabled="onGoingJobs.length > 0 || closed"
        class="ma-0"
        icon
        @click="newJob = {}; dialog = true">
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-layout>
      <v-flex>
        <v-divider/>
        <table
          v-if="jobs.length > 0"
          style="table-layout: fixed; width: 100%;">
          <tr>
            <td/>
            <td
              colspan="4"
              class="grey--text">
              Job ID
            </td>
            <td
              colspan="4"
              class="grey--text">
              Status
            </td>
          </tr>
          <tr
            v-for="job in onGoingJobs"
            :key="job.id">
            <td><v-icon small>sync</v-icon></td>
            <td colspan="4">
              <router-link
                :to="{ name: 'job', params: { id: job.id } }"
                class="clickable">
                {{ job.id | formatJId }}
              </router-link>
            </td>
            <td colspan="4">
              <div v-if="job.status">{{ job.status.name }}</div>
              <v-tooltip
                v-if="job.expectedCompletion"
                transition="scale-transition"
                left>
                <span
                  slot="activator"
                  :class="[
                    {'green--text':
                      job.expectedCompletion > new Date().toISOString() },
                    {'red--text':
                      job.expectedCompletion < new Date().toISOString() },
                    'text--lighten-3']">
                  Expected completion
                  {{ job.expectedCompletion | formatFn }}
                </span>
                <span>{{ job.expectedCompletion | formatLLL }}</span>
              </v-tooltip>
            </td>
          </tr>
          <tr
            v-for="job in completedJobs"
            :key="job.name">
            <td>
              <v-icon
                color="grey"
                small>stop</v-icon>
            </td>
            <td colspan="4">
              <router-link
                :to="{ name: 'job', params: { id: job.id } }"
                class="clickable">
                {{ job.id | formatJId }}
              </router-link>
            </td>
            <td colspan="4">
              <span
                v-if="job.status"
                class="grey--text">
                {{ job.status.name }}
              </span>
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="dialog"
      :persistent="true"
      max-width="50rem">
      <v-card>
        <v-card-text>
          <v-container>
            <v-layout>
              <v-flex>
                <v-form v-model="valid">
                  <v-text-field
                    v-model="newJob.name"
                    :rules="[v => !!v || 'Name is required']"
                    label="Name"/>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "assigned-jobs",
  props: {
    closed: {
      required: true,
      type: Boolean
    },
    issueId: {
      required: true,
      type: Number
    },
    jobs: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      dialog: false,
      newJob: { name: "" },
      posting: false,
      valid: false
    };
  },
  computed: {
    completedJobs () {
      return this.
        jobs.
        filter((job) => job.completed).
        sort((j1, j2) => {
          if (j1.status.date > j2.status.date) {
            return -1;
          }
          return 1;
        });
    },
    onGoingJobs () {
      return this.jobs.filter((job) => !job.completed);
    }
  },
  methods: {
    ...mapActions(["notify"]),
    save () {
      this.posting = true;
      this.$http.
        post("/api/jobs", {
          issueId: this.issueId,
          name: this.newJob.name
        }).
        then((r) => {
          this.dialog = false;
          this.posting = false;
          this.$router.push({
            name: "job",
            params: { id: r.data.id }
          });
        }).
        catch((err) => {
          this.posting = false;
          if (err.response.status === 403) {
            const msg = "Error! Make sure that you have defined " +
                        "at least one job status in the admin section.";
            this.notify({ msg });
          }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Issue/AssignedJobs.vue